import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import TopTeams from "../Components/TopTeams";
import Config from "../../Utility/Config";
import Utility from "../../Utility/Utility";

import {
  getPlayerListApi,
  getCoachListApi,
  createTeamApi,
  getTeamListApi,
} from "./TeamController";
import { imageUploadApi, getCountryApi } from "../../Login/Controller/LoginController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";

const CreateTeam = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { language } = useSelector((state) => state.language);
  const { userDetails, token, userType } = useSelector((state) => state.user);

  const imageUrl = `${Config.BASE_URL}${Config.EXTENDED_URL}`;

  // ------------------ COUNTRY DROPDOWN ------------------
  const [openCountry, setOpenCountry] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("FRENCH");
  const countryRef = useRef(null);

  const [playerList, setPlayerList] = useState([]);
  const [coachList, setCoachList] = useState([]);
  const [countries, setCountryList] = useState([]);
  const [teamsPlayer, setTeamsPlayer] = useState([]);
  console.log("playerListplayerListplayerList", playerList);
  const [teamList, setTeamList] = useState([]);

  const activeCountry = countries.find(
    (item) => item.name === selectedCountry
  );

  useEffect(() => {
    getCountryList();
    getTeamList();
  }, []);

  const getCountryList = () => {
    try {
      dispatch(loaderStateTrue());
      getCountryApi()
        .then((response) => {
          let responseData = response.data || [];
          setCountryList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  const getTeamList = () => {
    try {
      dispatch(loaderStateTrue());
      getTeamListApi()
        .then((response) => {
          let responseData = response.data || [];
          console.log("responseDataresponseDataresponseData", responseData)
          setTeamList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  // ------------------ USER DROPDOWN ------------------
  const [openUser, setOpenUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState("JOHN");

  console.log("selectedUserselectedUserselectedUser", selectedUser);
  const userRef = useRef(null);
  const activeUser = coachList.find((coach) => coach._id === selectedUser);

  console.log("activeUseractiveUseractiveUser", activeUser);

  // ------------------ CLICK OUTSIDE CLOSE ------------------
  useEffect(() => {
    function handleClickOutside(e) {
      if (countryRef.current && !countryRef.current.contains(e.target)) {
        setOpenCountry(false);
      }
      if (userRef.current && !userRef.current.contains(e.target)) {
        setOpenUser(false);
      }
      if (userRef.current && !userRef.current.contains(e.target)) {
        setOpenUser(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ------------------ PLAYER DROPDOWN ------------------
  const [openPlayer, setOpenPlayer] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState("VIRAT");
  const playerRef = useRef(null);

  const activePlayer = playerList.find((item) => item._id === selectedPlayer);

  const [teamOpen, setTeamOpen] = useState(false);
  const teamRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (teamRef.current && !teamRef.current.contains(e.target)) {
        setTeamOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (playerRef.current && !playerRef.current.contains(event.target)) {
        setOpenPlayer(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectPlayer = (element) => {
    if (!element) {
      setLoginError((prev) => ({
        ...prev,
        playersId: "Please select a player",
      }));
      return;
    }

    setTeamsPlayer((prev) => [...prev, element]);
    setPlayerList((prev) => prev.filter((player) => player.id !== element.id));
    setTeamData((prev) => ({
      ...prev,
      playersId: [...(prev.playersId || []), element.id],
    }));
    setLoginError((prev) => ({ ...prev, playersId: "" }));
    setOpenPlayer(false);
    setSelectedPlayer(element.id);
  };

  const [teamData, setTeamData] = useState({
    name: "",
    coach: userDetails._id,
    country: "",
    playersId: [],
    logo: "",
    shortName: "",
  });

  const [teamError, setLoginError] = useState({
    name: "",
    coach: "",
    country: "",
    playersId: "",
    logo: "",
    shortName: "",
  });

  const validateLogin = () => {
    let valid = true;
    if (teamData.name.trim() === "") {
      valid = false;
      setLoginError({ ...teamError, name: t("requiredField") });
    } else {
      setLoginError({ ...teamError, name: "" });
    }
    if (teamData.coach.trim() === "") {
      valid = false;
      setLoginError({ ...teamError, coach: t("requiredField") });
    } else {
      setLoginError({ ...teamError, coach: "" });
    }
    if (teamData.country.trim() === "") {
      valid = false;
      setLoginError({ ...teamError, country: t("requiredField") });
    } else {
      setLoginError({ ...teamError, country: "" });
    }
    return valid;
  };

  const handleCreate = () => {
    let valid = validateLogin();
    if (valid) {
      dispatch(loaderStateTrue());
      createTeamApi(teamData)
        .then(async (response) => {
          console.log("responseresponseresponseresponse", response)
          if (response.status) {
            setTimeout(() => {
              dispatch(loaderStateFalse());
              navigate(`/${language}/team-management`);
            }, 1000);
            Utility.toastNotifications(response.message, "Success", "success");
          } else {
            dispatch(loaderStateFalse());
            Utility.toastNotifications(response.message, "Error", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          Utility.toastNotifications(
            error.response.data.message,
            "Error",
            "error"
          );
          if (error.response.status === 401) {
            Utility.toastNotifications(
              error.response.data.message,
              "Error",
              "error"
            );
          }
          dispatch(loaderStateFalse());
        });
    }
  };

  const handleImageUpload = (file) => {
    dispatch(loaderStateTrue());
    imageUploadApi(file)
      .then((response) => {
        if (response.status) {
          console.log("responseresponseresponse", response)
          setTeamData((prev) => ({
            ...prev,
            logo: response.data?.url || "",
          }));
          dispatch(loaderStateFalse());
          Utility.toastNotifications(response.message, "Success", "success");
        } else {
          dispatch(loaderStateFalse());
          Utility.toastNotifications(response.message, "Error", "error");
        }
      })
      .catch((error) => {
        dispatch(loaderStateFalse());
        Utility.toastNotifications("Upload failed", "Error", "error");
      });
  };

  return (
    <main className="main p-4 relative">
      <div className="flex flex-col">
        <div className="flex flex-wrap items-start gap-y-6 -mx-2">
          <div className="lg:w-4/6 w-full px-2">
            <div className="space-y-5">
              <div className="relative">
                <div className="relative rounded-xl bg-gray-50 h-full">
                  <div className="absolute inset-0 rounded-xl overflow-hidden">
                    <div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
                    <div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
                    <div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
                  </div>
                  <div className="flex max-sm:flex-wrap gap-3 justify-between relative">
                    <div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
                      <div className="space-y-2">
                        <h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">
                          Create a new team
                        </h2>
                        <p className="text-base font-medium text-gray-400">
                          Dummy text of the printing and typesetting industry.
                        </p>
                      </div>
                    </div>
                    <div className="lg:-mt-4 text-center">
                      <img
                        src="assets/images/teams.png"
                        alt=""
                        className="w-full inline-block rounded-br-xl"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-y-4 -mx-2">
                <div className="xs:w-1/2 w-full px-2">
                  <label className="form-label">Team Name</label>
                  {/* <input type="text" className="form-control" /> */}
                  <input
                    type="text"
                    id="name"
                    // placeholder={t("email")}
                    placeholder="Team Name"
                    className="form-control"
                    onChange={(e) => {
                      setTeamData({ ...teamData, name: e.target.value });
                      setLoginError({ ...teamError, name: "" });
                    }}
                    value={teamData.name}
                  />
                  <span className="text-red-500">{teamError.name}</span>
                </div>

                <div className="xs:w-1/2 w-full px-2">
                  <label className="form-label">Country</label>

                  <div className="dropdown border rounded-lg bg-white relative">
                    <div className="relative z-[1]" ref={countryRef}>
                      <button
                        className="flex items-center gap-2 px-4 py-2.5 w-full cursor-pointer"
                        onClick={() => setOpenCountry(!openCountry)}
                      >
                        <img
                          src={activeCountry?.flag}
                          className="size-6 rounded-full"
                          alt=""
                        />
                        <span>{activeCountry?.name}</span>

                        <img
                          src="assets/images/icons/arrow-chevron-downward.svg"
                          className={`ml-auto transition-transform ${openCountry ? "rotate-180" : ""
                            }`}
                          alt=""
                        />
                      </button>

                      {/* Country Menu */}
                      <div
                        className={`absolute w-full bg-white shadow-lg border rounded-lg max-h-64 overflow-auto transition-all scrollbar-custom
                                        ${openCountry
                            ? "opacity-100 visible scale-100"
                            : "opacity-0 invisible scale-95"
                          }`}
                      >
                        <ul>
                          {countries.map((item, index) => (
                            <li
                              key={index}
                              className={`px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100 
                                                ${selectedCountry === item.name
                                  ? "bg-gray-200 font-semibold"
                                  : ""
                                }`}
                              onClick={() => {
                                setSelectedCountry(item.name);
                                setTeamData({
                                  ...teamData,
                                  country: item._id,
                                });
                                setLoginError({ ...teamError, country: "" });
                                setOpenCountry(false);
                              }}
                            >
                              <img src={item.flag} className="size-6 rounded-full object-cover" alt="" />
                              {item.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <span className="text-red-500">{teamError.country}</span>
                    </div>
                  </div>
                </div>

                <div className="w-full px-2">
                  <div className="flex items-center justify-center w-full">
                    <label
                      for="dropzone-file"
                      className="flex flex-col items-center justify-center w-full h-48 bg-neutral-secondary-medium border-2 border-dashed border-default-strong border-gray-200 rounded-xl cursor-pointer hover:bg-neutral-tertiary-medium"
                    >
                      <div className="flex flex-col items-center justify-center text-body pt-5 pb-6">
                        <div className="bg-gradient-to-r from-primary-500 via-primary-700 to-primary-950 text-white rounded-full p-1 size-8 flex justify-center items-center">
                          <img
                            src="assets/images/icons/plus.svg"
                            alt=""
                            className="icon-white flex-none size-full"
                          />
                        </div>
                        <plabel className="my-2 uppercase">
                          <span className="font-semibold">Add a Team logo</span>
                        </plabel>
                        <p className="font-medium text-gray-400">
                          Dummy text of the printing and typesetting industry.
                        </p>
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        onChange={(e) => handleImageUpload(e.target.files[0])}
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                <div>
                  <h3 className="text-lg font-extrabold uppercase">Notes</h3>
                  <p className="text-gray-400">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                </div>
                {/* <button className="btn btn-primary text-nowrap ml-auto">Proceed</button> */}

                <button
                  className="btn btn-primary text-nowrap ml-auto"
                  // onClick={() => navigate("/en/team-management")}
                  onClick={handleCreate}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
          <div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
            <div className="space-y-5">
              <div className="panel">
                {/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                                <div className="flex justify-between gap-3 w-full">
                                    <button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
                                    <h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
                                    <button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
                                </div>
                            </div> */}
                <div className="panel-body w-full space-y-8">
                  <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div className="p-5 relative space-y-3">
                      <div className="flex justify-between items-center gap-4 w-full">
                        <div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">
                          sÊrie de victoires
                        </div>
                        <div className="flex-none pr-5">
                          <span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">
                            70%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TopTeams tableName={"topTeams"} teamList={teamList} />

              <div className="panel">
                <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                  <div className="flex justify-between gap-3 w-full">
                    <h3 className="xl:text-lg text-base font-extrabold uppercase">
                      Meilleurs joueurs
                    </h3>
                    <div className="flex items-center gap-4">
                      <button className="cursor-pointer">
                        <img
                          src="assets/images/icons/arrow-chevron-left.svg"
                          alt=""
                        />
                      </button>
                      <button className="cursor-pointer">
                        <img
                          src="assets/images/icons/arrow-chevron-right.svg"
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="panel-body w-full">
                  <div className="pt-5">
                    <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                      <div className="px-5 relative space-y-3">
                        <div className="flex justify-between items-start gap-4 w-full">
                          <h4 className="lg:text-2xl text-lg font-black uppercase py-5">
                            Kamory Doumbia
                          </h4>
                          <div className="flex-none w-2/3 -mt-4">
                            <img
                              src="assets/images/club-players/kamory-doumbia.png"
                              alt=""
                              className="max-w-full"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                                        <div className="px-5 relative space-y-3">
                                            <div className="flex justify-between items-start gap-4 w-full">
                                                <h4 className="lg:text-2xl text-lg font-black uppercase py-5">JulienLe Cardinal</h4>
                                                <div className="flex-none w-2/3 -mt-4">
                                                    <img src="assets/images/club-players/julienLe-cardinal.png" alt="" className="max-w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CreateTeam;
